// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import ProductFeaturesTable from './product-features-table';
// assets
//

// ----------------------------------------------------------------------

export default function ProductFeatures() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <ProductFeaturesTable />
        </Container >
    );
}
